import Button from '@mui/material/Button';
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./patientActionButton.scss";
let PatientRegistrationTime = [
  {
    infoType: "Basic Information",
    pathName: "basic-information"
  },
  {
    infoType: "Diagnosis",
    pathName: "diagnosis"
  },
  {
    infoType: "Vital Parmeter",
    pathName: "vital-parmeter"
  },
  {
    infoType: "Lifestyle",
    pathName: "lifestyle"
  },
  {
    infoType: "Medical History",
    pathName: "medical-history"
  },
  {
    infoType: "Insurance",
    pathName: "insurance"
  },
  {
    infoType: "Corporate Details",
    pathName: "corporate-details"
  },
  {
    infoType: "Billing Info",
    pathName: "billing-info"
  },
  {
    infoType: "Attendant",
    pathName: "attendant"
  },
  {
    infoType: "Family History",
    pathName: "family-history"
  }
]


const PatientAction = (props) => {
  const { isDisabled } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (event, index) => {
    event?.preventDefault();
    if (PatientRegistrationTime[index]) {
      navigate(`/patient-registration/${PatientRegistrationTime[index]?.pathName}`, { state: { addPatient: false, rowData: location?.state?.rowData } })
    }
  }
  return (
    <>
     
      {Object.keys(location && location?.state?.rowData)?.length > 0 ? 
      <div className="action-buttons">
          <div className="card">
            <div className="card-body d-flex justify-content-between">
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-user" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{location?.state?.rowData?.name}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-child" aria-hidden="true"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{location?.state?.rowData?.age}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag"><i class="fa fa-mobile" aria-hidden="true"></i>&nbsp;:&nbsp;	</p>
                <p className="action-value-tag">{location?.state?.rowData?.mobile}</p>
              </div>
              <div className="d-flex">
                <p className="action-key-tag" ><i class="fa fa-list-ol" aria-hidden="true" tooltip="EMR Number"></i>&nbsp;:&nbsp;</p>
                <p className="action-value-tag">{location?.state?.rowData?.emrNumber}</p>
              </div>
            </div>
          </div>
      </div> : null}
      <div className="patient-timeline">
        {
          PatientRegistrationTime &&PatientRegistrationTime?.length > 0 &&  PatientRegistrationTime?.map((ele, index) => {
            return (
              <div className="parent" key={index}>
                <div className="btn"
                  onClick={(e) => !isDisabled ? handleNavigation(e, index) : null}>
                  <Button variant="outlined"
                    disabled={isDisabled && isDisabled}
                    onClick={(e) => handleNavigation(e, index)} name={ele?.infoType}>{ele?.infoType}</Button>
                </div>
              </div>
            )
          })
        }
      </div>
    </>
  )
}

export default PatientAction;